<template>
  <div>
    <ol class="breadcrumb float-xl-end">
      <li class="breadcrumb-item">
        <router-link to="/base-data/partners">Partnerek</router-link>
      </li>
      <li class="breadcrumb-item active">{{ partner.name }}</li>
    </ol>
    <h1 class="page-header">Partner szerkesztése</h1>
    <Loading v-if="partner === false" title="Partner betöltése"></Loading>
    <NoRecords
      v-if="partner.notfound"
      main_icon="fas fa-user-lock"
      value="false"
      title="Nem található a partner"
      subtitle="Menjen vissza a partnerekhez!"
    ></NoRecords>
    <div class="row" v-if="partner !== false && !partner.notfound">
      <div class="col-md-6">
        <panel title="Adatok">
          <form @submit.prevent="updatePartner()">
            <div class="form-group">
              <label class="form-label">Név:</label>
              <input
                class="form-control"
                :class="{ 'is-invalid': errors.name }"
                type="text"
                v-model="partner.name"
                required
              />
              <div v-if="errors.name" class="invalid-feedback d-block">
                {{ errors.name[0] }}
              </div>
            </div>
            <div class="form-group">
              <label class="form-label">Cím:</label>
              <input
                class="form-control"
                :class="{ 'is-invalid': errors.site_address }"
                type="text"
                v-model="partner.site_address"
              />
              <div v-if="errors.site_address" class="invalid-feedback d-block">
                {{ errors.site_address[0] }}
              </div>
            </div>
            <div class="form-group">
              <label class="form-label">Adószám:</label>
              <masked-input
                pattern="11111111-1-11"
                class="form-control"
                placeholder="99999999-9-99"
                :class="{ 'is-invalid': errors.vat_number }"
                type="text"
                v-model="partner.vat_number"
                required
              ></masked-input>
              <div v-if="errors.vat_number" class="invalid-feedback d-block">
                {{ errors.vat_number[0] }}
              </div>
            </div>
            <div class="text-end mt-2">
              <button class="btn btn-primary">
                <i class="fa fa-save"></i> Mentés
              </button>
            </div>
          </form>
        </panel>
        <panel title="Felhasználók">
          <Loading
            v-if="users === false"
            title="Felhasználók betöltése"
          ></Loading>
          <div class="text-end mb-2" v-if="users !== false">
            <button
              class="btn btn-success btn-rounded px-4 rounded-pill"
              v-b-modal.addUserModal
            >
              <i class="fa fa-plus fa-lg me-2 ms-n2 text-success-900"></i> Új
              felhasználó
            </button>
            <AddUserModal
              v-on:partner-user-added="addUserToTable"
              :partner_id="partner.id"
              title="Partner felhasználó hozzáadása"
              no_email="true"
              role_id="11"
              :cant_choose_role="true"
            ></AddUserModal>
          </div>
          <NoRecords
            v-if="users.length == 0"
            main_icon="fas fa-users"
            value="false"
            title="Nem található a partnerhez rendelt felhasználó"
            subtitle="Adjon hozzá újat!"
          ></NoRecords>
          <div v-if="users.length != 0 && users !== false">
            <vue-good-table
              :columns="columns"
              :rows="users"
              :lineNumbers="true"
              :search-options="{ enabled: false, placeholder: 'Keresés...' }"
              :pagination-options="{
                enabled: true,
                position: 'bottom',
                firstLabel: 'Első Lap',
                lastLabel: 'Utolsó Lap',
                nextLabel: 'következő',
                prevLabel: 'előző',
                rowsPerPageLabel: 'Sor oldalanként',
                ofLabel: '/',
                allLabel: 'Összes',
                infoFn: (params) => `első sorszám: ${params.firstRecordOnPage}`,
              }"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'actions'">
                  <button
                    :disabled="props.row.role_id == 10"
                    @click="confirmDelete(props.row.id)"
                    class="btn btn-danger mx-1"
                    title="törlés"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </div>
        </panel>
      </div>
      <div class="col-md-6">
        <panel title="Munkajegyek">
          munkajegyek amikhez van rendelve user a partner userei közül
        </panel>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "../../components/Loading";
import NoRecords from "../../components/NoRecords";
import Partner from "../../apis/Partner";
import User from "../../apis/User";
import AddUserModal from "../../components/AddUserModal";
import Confirmation from "../../apis/Confirmation";

export default {
  components: {
    Loading,
    NoRecords,
    AddUserModal,
  },
  data() {
    return {
      columns: [
        {
          label: "Név",
          field: "name",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a nevek között",
          },
        },
        {
          label: "Létrehozás dátuma",
          field: "created_at",
          type: "date",
          dateInputFormat: "yyyy-MM-dd'T'HH:mm:ss.SSSSSSXXX",
          dateOutputFormat: "yyyy-MM-dd",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a létrehozási dátumok között",
          },
        },
        {
          label: "Műveletek",
          field: "actions",
          width: "15%",
          sortable: false,
          thClass: "text-end",
          tdClass: "text-end",
        },
      ],
      partner: false,
      users: false,
      errors: [],
    };
  },
  created() {
    Partner.show(this.$route.params.id)
      .then((response) => {
        this.$set(this, "partner", response.data);
      })
      .catch(() => {
        this.$set(this, "partner", { name: "ismeretlen", notfound: true });
      });
    Partner.getUsers(this.$route.params.id).then((response) => {
      this.$set(this, "users", response.data);
    });
  },
  methods: {
    addUserToTable(user) {
      this.users.push(user);
    },
    updatePartner() {
      Partner.update(this.$route.params.id, this.partner)
        .then(() => {
          console.log("siker");
        })
        .catch((error) => {
          if (error.response.data.errors) {
            this.errors = error.response.data.errors;
          }
        });
    },
    confirmDelete(id) {
      Confirmation.swalDelete().then((response) => {
        if (response.isConfirmed === true) {
          this.deleteUser(id);
        }
      });
    },
    deleteUser(id) {
      User.delete(id).then(() => {
        this.users.splice(this.users.map((user) => user.id).indexOf(id), 1);
      });
    },
  },
};
</script>

<style></style>
